import { render, staticRenderFns } from "./AddressVerificationFilter.vue?vue&type=template&id=497eac94&"
import script from "./AddressVerificationFilter.vue?vue&type=script&lang=js&"
export * from "./AddressVerificationFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports